// extracted by mini-css-extract-plugin
export var wordContainer = "_rp-0";